(function(){
  if(window.__dtfchi) return;
  window.__dtfchi=true;

  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s,r){ return [].slice.call((r||document).querySelectorAll(s)); }
  function once(el,key){ if(el['__'+key]) return false; el['__'+key]=true; return true; }

  function header(root){
    $$('.dc-hd',root).forEach(function(hd){
      if(!once(hd,'hd')) return;
      var wrap=hd.closest('.dc-root'), scrim=wrap.querySelector('.dc-scrim'), drawer=wrap.querySelector('.dc-drawer');
      function stick(){ hd.classList.toggle('dc-is-stuck', window.scrollY>40); }
      function measure(){ if(!hd.classList.contains('dc-is-stuck')) document.documentElement.style.setProperty('--dc-hdh', hd.offsetHeight+'px'); }
      window.addEventListener('scroll',stick,{passive:true}); stick();
      if(window.ResizeObserver) new ResizeObserver(measure).observe(hd);
      window.addEventListener('resize',measure); measure();

      var items=$$('.dc-menu > li',hd), t;
      function closeMenus(){ items.forEach(function(li){ li.classList.remove('dc-open'); var b=li.querySelector('button'); if(b) b.setAttribute('aria-expanded','false'); }); scrim.classList.remove('dc-on'); }
      function openMenu(li){ closeMenus(); li.classList.add('dc-open'); li.querySelector('button').setAttribute('aria-expanded','true'); scrim.classList.add('dc-on'); }
      items.forEach(function(li){
        var b=li.querySelector('button.dc-menu__top');
        if(!b){ li.addEventListener('mouseenter',function(){ clearTimeout(t); t=setTimeout(closeMenus,80); }); return; }
        li.addEventListener('mouseenter',function(){ clearTimeout(t); t=setTimeout(function(){ openMenu(li); },90); });
        li.addEventListener('mouseleave',function(){ clearTimeout(t); t=setTimeout(closeMenus,160); });
        b.addEventListener('click',function(){ li.classList.contains('dc-open')?closeMenus():openMenu(li); });
      });

      function openD(){ drawer.classList.add('dc-on'); drawer.setAttribute('aria-hidden','false'); scrim.classList.add('dc-on'); document.body.style.overflow='hidden'; }
      function closeD(){ drawer.classList.remove('dc-on'); drawer.setAttribute('aria-hidden','true'); scrim.classList.remove('dc-on'); document.body.style.overflow=''; }
      $$('.js-open-drawer',wrap).forEach(function(b){ b.addEventListener('click',openD); });
      $$('.js-close-drawer',wrap).forEach(function(b){ b.addEventListener('click',closeD); });
      scrim.addEventListener('click',function(){ closeMenus(); closeD(); });
      $$('.dc-acc > button',drawer).forEach(function(b){ b.addEventListener('click',function(){ b.parentNode.classList.toggle('dc-open'); }); });
      $$('.dc-drawer a[href^="#"]',wrap).forEach(function(a){ a.addEventListener('click',closeD); });

      var sBtns=$$('.js-search',hd), sPanel=hd.querySelector('.dc-sdrop'), sInput=sPanel.querySelector('input[type=search]');
      function openS(){ hd.classList.add('dc-s-open'); sPanel.setAttribute('aria-hidden','false'); sBtns.forEach(function(b){ b.setAttribute('aria-expanded','true'); }); setTimeout(function(){ sInput.focus(); },60); }
      function closeS(){ hd.classList.remove('dc-s-open'); sPanel.setAttribute('aria-hidden','true'); sBtns.forEach(function(b){ b.setAttribute('aria-expanded','false'); }); }
      sBtns.forEach(function(b){ b.addEventListener('click',function(){ hd.classList.contains('dc-s-open')?closeS():openS(); }); });
      $$('.js-close-search',hd).forEach(function(b){ b.addEventListener('click',closeS); });
      document.addEventListener('click',function(e){ if(hd.classList.contains('dc-s-open') && !sPanel.contains(e.target) && !sBtns.some(function(b){ return b.contains(e.target); })) closeS(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeMenus(); closeD(); closeS(); } });

      sameday(hd);
    });
  }

  function sameday(hd){
    var cutoff=Number(hd.getAttribute('data-cutoff')||15), open=Number(hd.getAttribute('data-open')||9);
    var days=(hd.getAttribute('data-days')||'1,2,3,4,5,6').split(',').map(Number);
    var tz=hd.getAttribute('data-tz')||'America/Chicago';
    var L={by:hd.getAttribute('data-l-by'),inn:hd.getAttribute('data-l-in'),fr:hd.getAttribute('data-l-for'),ready:hd.getAttribute('data-l-ready'),ifn:hd.getAttribute('data-l-if'),tomorrow:hd.getAttribute('data-l-tomorrow')};
    var names=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var cutLabel=(cutoff%12||12)+(cutoff<12?' AM':' PM');
    var els=$$('[data-sameday]',hd.closest('.dc-root'));
    if(!els.length) return;
    function now(){
      var p=new Intl.DateTimeFormat('en-US',{timeZone:tz,weekday:'short',hour:'numeric',minute:'numeric',second:'numeric',hour12:false}).formatToParts(new Date()), o={};
      p.forEach(function(x){ o[x.type]=x.value; });
      return {d:['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(o.weekday),h:Number(o.hour)%24,m:Number(o.minute),s:Number(o.second)};
    }
    function nextDay(d){ for(var i=1;i<8;i++){ var n=(d+i)%7; if(days.indexOf(n)>-1) return i===1?L.tomorrow:names[n]; } return ''; }
    function tick(){
      var c=now(), mins=c.h*60+c.m, t1, t2;
      if(days.indexOf(c.d)>-1 && mins<cutoff*60){
        if(mins<open*60){ t1=L.by+' <b>'+cutLabel+'</b>'; }
        else { var left=cutoff*60-mins-(c.s?1:0), h=Math.floor(left/60), m=left%60; t1=L.inn+' <b>'+(h?h+'h ':'')+m+'m'+(h?'':' '+(59-c.s)+'s')+'</b>'; }
        t2=L.fr;
      } else { t1=L.ready+' <b>'+nextDay(c.d)+'</b>'; t2=L.ifn; }
      els.forEach(function(el){
        var a=el.querySelector('.dc-sd__t1'), b=el.querySelector('.dc-sd__t2'), one=el.querySelector('.sd__one');
        if(a) a.innerHTML=t1;
        if(b) b.innerHTML=t2;
        if(one) one.innerHTML=t1+' '+t2;
      });
    }
    tick(); setInterval(tick,1000);
  }

  var SPARKS=[[6,72,15,'#4AA3E8'],[30,97,12,'#8E6BE0'],[52,68,17,'#E2337E'],[77,98,12,'#F07A3E'],[98,70,15,'#F6A21E'],[90,4,12,'#ffffff'],[17,3,10,'#ffffff']];
  function logoLight(root){
    $$('img.js-light',root).forEach(function(img){
      if(!once(img,'light')) return;
      var w=document.createElement('span'); w.className='dc-lfx';
      img.parentNode.insertBefore(w,img); w.appendChild(img);
      function setMask(){ w.style.setProperty('--dc-logo','url("'+(img.currentSrc||img.src)+'")'); }
      if(img.complete) setMask(); else img.addEventListener('load',setMask);
      SPARKS.forEach(function(p){
        var i=document.createElement('i'), at=1+1.68*((p[0]/100+0.24)/1.48);
        i.style.cssText='--dc-x:'+p[0]+'%;--dc-y:'+p[1]+'%;--dc-s:'+p[2]+'px;--dc-c:'+p[3]+';--dc-d:'+(at-0.24).toFixed(2)+'s';
        w.appendChild(i);
      });
    });
  }

  function hero(root){
    $$('.dc-hero',root).forEach(function(h){
      if(!once(h,'hero')) return;
      if(h.classList.contains('dc-hero--overlap')) document.documentElement.classList.add('dc-overlap');
      var v=h.querySelector('video');
      if(!v){ h.classList.add('dc-vid-fail'); return; }
      v.muted=true; v.setAttribute('playsinline','');
      var srcs=v.querySelectorAll('source');
      function fail(){ h.classList.add('dc-vid-fail'); }
      if(srcs.length) srcs[srcs.length-1].addEventListener('error',fail);
      v.addEventListener('error',fail);
      if(reduce){ fail(); return; }
      var pr=v.play&&v.play(); if(pr&&pr.catch) pr.catch(function(){});
    });
  }

  function rails(root){
    $$('.dc-rail',root).forEach(function(rail){
      if(!once(rail,'rail')) return;
      var box=rail.closest('.dc-wrap'), dots=box.querySelector('.dc-rail__dots');
      function pw(){ return rail.clientWidth; }
      function pages(){ return Math.max(1,Math.ceil((rail.scrollWidth-2)/pw())); }
      function mark(){ var max=rail.scrollWidth-pw(), idx=max<=0?0:Math.round(rail.scrollLeft/max*(pages()-1)); [].forEach.call(dots.children,function(d,i){ d.classList.toggle('dc-on',i===idx); }); }
      function build(){ dots.innerHTML=''; for(var i=0;i<pages();i++){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Go to page '+(i+1)); (function(n){ b.addEventListener('click',function(){ rail.scrollTo({left:n*pw()}); }); })(i); dots.appendChild(b); } mark(); }
      function go(dir){ var max=rail.scrollWidth-pw(), next=rail.scrollLeft+dir*pw(); if(next>max+4) next=0; if(next<-4) next=max; rail.scrollTo({left:next}); }
      $$('[data-rail]',box).forEach(function(b){ b.addEventListener('click',function(){ go(Number(b.getAttribute('data-rail'))); }); });
      rail.addEventListener('scroll',mark,{passive:true});
      window.addEventListener('resize',build); build();
      if(!reduce && rail.hasAttribute('data-autoplay')){
        var paused=false;
        rail.addEventListener('mouseenter',function(){ paused=true; });
        rail.addEventListener('mouseleave',function(){ paused=false; });
        rail.addEventListener('touchstart',function(){ paused=true; },{passive:true});
        setInterval(function(){ if(!paused && !document.hidden) go(1); },4500);
      }
    });
  }

  function lanes(root){
    $$('.dc-lane',root).forEach(function(l){
      if(!once(l,'lane')) return;
      var copy=l.innerHTML.replace(/<article class="rev"/g,'<article class="dc-rev" aria-hidden="true"');
      l.insertAdjacentHTML('beforeend',copy);
    });
    $$('.dc-feats-m',root).forEach(function(box){
      if(!once(box,'flane')) return;
      var feats=$$('.dc-feats .dc-feat',box.parentNode);
      $$('.dc-flane',box).forEach(function(l,i){
        var set=feats.filter(function(_,k){ return k%2===i; }).map(function(f){ return f.outerHTML; }).join('');
        l.innerHTML=set+set;
      });
    });
  }

  function compares(root){
    $$('.dc-compare',root).forEach(function(el){
      if(!once(el,'cmp')) return;
      var input=el.querySelector('input');
      input.addEventListener('input',function(){ el.style.setProperty('--dc-pos',input.value+'%'); });
    });
  }

  function locations(root){
    $$('.dc-visit',root).forEach(function(sec){
      if(!once(sec,'loc')) return;
      var map=sec.querySelector('iframe'), cards=$$('.dc-loc',sec);
      cards.forEach(function(card){
        function pick(){
          cards.forEach(function(c){ c.classList.toggle('dc-on',c===card); });
          if(map){ map.src='https://maps.google.com/maps?q='+encodeURIComponent(card.getAttribute('data-map'))+'&z=15&output=embed'; map.title=card.getAttribute('data-title'); }
        }
        card.addEventListener('click',function(e){ if(!e.target.closest('a')) pick(); });
        card.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } });
      });
    });
  }

  function drops(root){
    $$('.dc-drop',root).forEach(function(drop){
      if(!once(drop,'drop')) return;
      var fileIn=drop.querySelector('input[type=file]'), list=drop.querySelector('.dc-drop__list');
      function kb(n){ return n>1048576?(n/1048576).toFixed(1)+' MB':Math.max(1,Math.round(n/1024))+' KB'; }
      function show(){ list.innerHTML=''; [].forEach.call(fileIn.files,function(f){ var li=document.createElement('li'); li.textContent=f.name; var s=document.createElement('small'); s.textContent=kb(f.size); li.appendChild(s); list.appendChild(li); }); }
      fileIn.addEventListener('change',show);
      ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.classList.add('dc-is-over'); }); });
      ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.classList.remove('dc-is-over'); }); });
      drop.addEventListener('drop',function(e){ if(e.dataTransfer&&e.dataTransfer.files.length){ fileIn.files=e.dataTransfer.files; show(); } });
    });
  }

  function bgVideos(root){
    $$('.dc-sec-bg video',root).forEach(function(v){
      if(!once(v,'bgv') || reduce) return;
      v.muted=true; v.setAttribute('playsinline','');
      var pr=v.play&&v.play(); if(pr&&pr.catch) pr.catch(function(){});
    });
  }

  function marquee(root){
    $$('.dc-ann__run',root).forEach(function(run){ if(once(run,'ann')) run.innerHTML+=run.innerHTML; });
  }

  function init(root){
    root=root||document;
    marquee(root); header(root); logoLight(root); hero(root); rails(root); lanes(root); compares(root); locations(root); drops(root); bgVideos(root);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
